// FILE: src/components/admin/PhoneList.jsx
// On a phone a wide table becomes a list of cards (WP-7, matrix 10.2, owner:
// everything usable at phone width): the same facts, one item per row, no
// sideways scrolling to reach a status or an action. Pages pick the layout
// with useIsPhone(); tables stay the layout on tablets and desktops.
import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function useIsPhone() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
}

/** A labelled list of cards. */
export function PhoneList({ label, children }) {
  return (
    <Box component="ul" aria-label={label} sx={{ listStyle: "none", m: 0, p: 0, display: "grid", gap: 1.5 }}>
      {children}
    </Box>
  );
}

export function PhoneCard({ children }) {
  return (
    <Box
      component="li"
      sx={{ border: "1px solid", borderColor: "divider", borderRadius: 3, p: 2, display: "grid", gap: 1.25, minWidth: 0 }}
    >
      {children}
    </Box>
  );
}
